import React, { useState, useContext } from "react";
import classnames from "classnames";
import { actions } from "@ignitesales/neuro-application";
import { connect } from "react-redux";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import GuideContext from "../../GuideContext";

const { startGuide } = actions.navigation;

function LandingPage({
  location,
  startGuideClicked,
  className,
  processingNavigation,
}) {
  const [started, setStarted] = useState(false);
  const { isBusinessGuide } = useContext(GuideContext);

  const startGuide = () => {
    setStarted(true);
    setTimeout(() => startGuideClicked((isBusinessGuide) ? "business-guide" : "consumer-guide", location), 1000);
  };

  const bemClass = "landingPage";
  const classes = classnames(
    bemClass,
    {
      [`${bemClass}--consumer`]: !isBusinessGuide,
      [`${bemClass}--business`]: isBusinessGuide,
    },
    className
  );
  return (
    <div className={classes}>
      <>
        <div className={`${bemClass}__bg`}></div>
        <div className={`${bemClass}__bg-border`}></div>
      </>
      <div className={`${bemClass}__container`}>
        <div className="title-action-container">
          <FormattedHTMLMessage id="landing.title" tagName="h1" />
          <FormattedHTMLMessage id="landing.message" tagName="p" />
          <button
            onClick={startGuide}
            disabled={processingNavigation}
            className="btn btn--white btn--large"
          >
            <FormattedMessage id="landing.getStarted" tagName="span" />
            <i className="fa fa-angle-right" />
          </button>
        </div>
      </div>
    </div>
  );
}

export { LandingPage as DisconnectedLandingPage };

export default connect(
  ({ processingNavigation = false }) => {
    return {
      processingNavigation,
    };
  },
  (dispatch) => {
    return {
      startGuideClicked: (selectedPath) => dispatch(startGuide(selectedPath)),
    };
  }
)(LandingPage);
